export const safeReadJson = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key)
    if (raw === null) {
      return fallback
    }
    return JSON.parse(raw)
  } catch {
    return fallback
  }
}

export const safeWriteJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // Ignore quota/private mode write failures.
  }
}

export const safeRemove = (key) => {
  try {
    localStorage.removeItem(key)
  } catch {
    // Ignore remove failures.
  }
}
